export default "__VITE_ASSET__12374911__"